// src/components/sops/SopReaders.js — leadhand-9cb21d86 (SOPs Library, Seam 5)
//
// "Who's read it" for a Lead Hand, under the confirm area in My SOPs: one row per person on this SOP's
// list (name, "(you)", status pill) and "X of Y read". View only — Managers set who must read it.
// READS: one server call (listSopReaders) per SOP selected; the server checks the Lead Hand is on the
// list and sends back names and reading status only. Shown only when MySops is told to (showSopReaders).
import React, { useEffect, useState } from 'react';
import { Notice } from './SopUi';
import { listReaders, friendlyError } from './sopsApi';
import { BADGE_CLASS, LEAD_READERS_FOOTNOTE, leadReaderPill, leadReadersCountText } from '../../utils/sopsUi';

export default function SopReaders({ sopId, versionId, readKey, timeZone }) {
    const [state, setState] = useState({ status: 'loading', res: null, error: '' });
    useEffect(() => {
        let live = true;
        setState({ status: 'loading', res: null, error: '' });
        listReaders(sopId)
            .then((res) => { if (live) setState({ status: 'done', res, error: '' }); })
            .catch((e) => { if (live) setState({ status: 'error', res: null, error: friendlyError(e, 'The reading list couldn’t be loaded.') }); });
        return () => { live = false; };
    }, [sopId, versionId, readKey]); // readKey: the Lead Hand's own confirm — reload so their row turns green

    const now = new Date();
    const { status, res, error } = state;
    return (
        <section className="mt-5 border-t pt-4" aria-label="Who's read it">
            <div className="flex items-baseline justify-between gap-3">
                <h3 className="text-sm font-semibold text-[#12192D]">Who’s read it</h3>
                {status === 'done' && <span className="text-sm text-gray-500">{leadReadersCountText(res)}</span>}
            </div>
            {status === 'loading' && <p className="mt-2 text-sm text-gray-500 animate-pulse">Loading…</p>}
            {status === 'error' && <div className="mt-2"><Notice tone="error">{error}</Notice></div>}
            {status === 'done' && (
                res.rows.length === 0 ? (
                    <p className="mt-2 text-sm text-gray-500">No one else is on this SOP’s list.</p>
                ) : (
                    <ul className="mt-2 divide-y rounded-lg border">
                        {res.rows.map((r, i) => {
                            const pill = leadReaderPill(r, now, timeZone);
                            return (
                                <li key={`${r.name}-${i}`} className="flex items-center justify-between gap-3 px-3 py-2">
                                    <span className="min-w-0 break-words text-sm text-[#12192D]">{r.name}{r.isYou ? ' (you)' : ''}</span>
                                    <span className={`inline-block whitespace-nowrap rounded-full border px-2 py-0.5 text-xs ${BADGE_CLASS[pill.kind]}`}>{pill.label}</span>
                                </li>
                            );
                        })}
                    </ul>
                )
            )}
            <p className="mt-2 text-xs text-gray-500">{LEAD_READERS_FOOTNOTE}</p>
        </section>
    );
}
